"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var React = require("react");

var semantic_ui_react_1 = require("semantic-ui-react");

var container_1 = require("../container");

var data_1 = require("../data");

var DatasetPage =
/** @class */
function (_super) {
  __extends(DatasetPage, _super);

  function DatasetPage(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      datasetLocation: '',
      visualizations: immutable_1.List()
    };
    return _this;
  }

  DatasetPage.prototype.componentDidMount = function () {
    if (this.props.location) {
      this.setupSearchParameters(this.props.location.search);
    }
  };

  DatasetPage.prototype.componentDidUpdate = function (prevProps) {
    if (this.props.location && this.props.location !== prevProps.location) {
      this.setupSearchParameters(this.props.location.search);
    }
  };

  DatasetPage.prototype.render = function () {
    var _this = this;

    var _a = this.state,
        visualizations = _a.visualizations,
        datasetLocation = _a.datasetLocation;
    return React.createElement("div", {
      style: {
        padding: '20px'
      }
    }, React.createElement(semantic_ui_react_1.Grid, {
      centered: true,
      stackable: true,
      stretched: false,
      padded: true,
      columns: 2
    }, datasetLocation.length >= 1 && visualizations.map(function (visualization, index) {
      return React.createElement(semantic_ui_react_1.Grid.Column, {
        key: "dataset-visualization-" + index,
        style: {
          width: 'auto'
        }
      }, _this.renderVisualization(visualization, datasetLocation));
    })));
  };

  DatasetPage.prototype.setupSearchParameters = function (query) {
    var params = new URLSearchParams(query); // tslint:disable-next-line:no-backbone-get-set-outside-model

    var datasetLocation = params.get('name');
    var visualizations = immutable_1.fromJS(params.getAll('viz'));
    this.setState({
      datasetLocation: datasetLocation ? datasetLocation : '',
      visualizations: visualizations
    });
  };

  DatasetPage.prototype.renderVisualization = function (viz, datasetLocation) {
    var isFullPage = this.state.visualizations.size === 1;

    switch (viz) {
      case data_1.VizData.spring.name.toLocaleLowerCase():
        return React.createElement(container_1.SpringContainer, {
          datasetLocation: datasetLocation,
          isFullPage: isFullPage
        });

      case data_1.VizData.tfjsTsne.name.toLocaleLowerCase():
        return React.createElement(container_1.TensorTContainer, {
          datasetLocation: datasetLocation,
          isFullPage: isFullPage
        });

      case data_1.VizData.anatomogram.name.toLocaleLowerCase():
        return React.createElement(container_1.AnatomogramContainer, {
          species: datasetLocation.includes('hpc') ? 'homo_sapiens' : 'mus_musculus'
        });

      default:
        return React.createElement(semantic_ui_react_1.Message, {
          error: true
        }, "Currently unsupported visualization '" + viz + "'");
    }
  };

  return DatasetPage;
}(React.Component);

exports.DatasetPage = DatasetPage;